module.exports = __webpack_public_path__ + "img/2025-charity-header.717bb210.png";